import { CreateUserBundleMappingInterface } from "../interfaces/UserBundleMappingInterface/CreateUserBundleMapping";
import { UserBundleMappingInterface } from "../interfaces/UserBundleMappingInterface/UserBundleMapping";
import BaseService from "./BaseService";

export class UserBundleMappingService extends BaseService<UserBundleMappingInterface, CreateUserBundleMappingInterface>{ 
    constructor(){
        let url: string = '/user-bundle-mapping/admin'
        super(url)
    }
}